import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../stockTransfers/forms/AddPalletForm";
import {cancelAddPalletToClientDispatch, successAddPalletToClientDispatch} from "../../../actions/ClientDispatchApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "kind");
  errors = validatePresence(errors, values, "palletId");
  return errors.toJS();
}

class AddPalletFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const kind = values.get("kind");
    const data = {
      clientDispatchId: this.props.clientDispatchId,
      palletId: values.get("palletId"),
    };
    const isWater = kind === "water";
    const mutation = isWater ? this.props.addWaterPalletToClientDispatch : this.props.addPalletToClientDispatch;

    return mutation(data)
      .then((response) => {
        const result = isWater
          ? response.data.addWaterPalletToClientDispatch
          : response.data.addPalletToClientDispatch;
        if (result.errors.length <= 0) {
          this.props.successAddPalletToClientDispatch();
        } else {
          // A water pallet can be refused per serial number (one already on
          // another transfer or dispatch, say); list every reason as the form's error.
          let errors = createValidationErrors(result.errors, result.errors.map((error) => error.message).join("\n"));
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelAddPalletToClientDispatch();
  }

  render() {
    return (
      <Form
        initialValues={Map({kind: "water"})}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ADD_WATER_PALLET_TO_CLIENT_DISPATCH = gql`
  mutation addWaterPalletToClientDispatch($data: ClientDispatchPalletInput!) {
    addWaterPalletToClientDispatch(input: $data) {
      errors { key message }
    }
  }
`;

const ADD_PALLET_TO_CLIENT_DISPATCH = gql`
  mutation addPalletToClientDispatch($data: ClientDispatchPalletInput!) {
    addPalletToClientDispatch(input: $data) {
      errors { key message }
    }
  }
`;

const withMutations = compose(
  graphql(ADD_WATER_PALLET_TO_CLIENT_DISPATCH, {
    props: ({ mutate }) => ({
      addWaterPalletToClientDispatch: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(ADD_PALLET_TO_CLIENT_DISPATCH, {
    props: ({ mutate }) => ({
      addPalletToClientDispatch: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
);

export default connect(null, {cancelAddPalletToClientDispatch, successAddPalletToClientDispatch})(withMutations(AddPalletFormContainer));
